import { NgModule } from '@angular/core';
import { AutosizeDirective } from './autosize/autosize.directive';

@NgModule({
	declarations: [AutosizeDirective],
	imports: [],
	exports: [AutosizeDirective]
})
export class DirectivesModule {}
